import React from 'react';
import css from './Thales.module.scss';
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import thalesBackground from "../../../assets/images/projectsImage/thalesBackground.jpeg";
import thalesLogo from "../../../assets/images/projectsImage/thalesLogo.png";

const Thales: React.FC = () => (
    <div className={css.project} id="thales">
        <img src={thalesBackground} alt=""/>
        <div className={css.projectInformationContainer}>

            <div className={css.projectName} style={{position: 'relative'}}>
                <h3>IDMS (Identity Management System)</h3>
                <Tooltip title="Thales">
                    <img src={ thalesLogo } width={150}
                         onClick={() => window.open('https://www.thalesgroup.com/en/',
                             "_blank")}
                         style={{marginLeft: '1em', position: 'absolute', right: 0, cursor: 'pointer'}}
                         alt=""/>
                </Tooltip>
            </div>

            <div className={css.infoSmallScreen}>
                <Chip label="Jun. 2022 - Present" size='small' variant="outlined"/>
            </div>
            <div className={css.info}>
                <Chip label="Jun. 2022 - Present" size='small' variant="outlined"/>
            </div>

            <h5 className={css.textSectionInfo}>Description:</h5>
            <p className={css.description}>IDMS is a web application that provides a centralized platform for storing and managing enrolled individuals. The main objective of this application is to ensure that the information of enrolled individuals is accurate, secure, and up-to-date.</p>
            <p className={css.description}>The application allows operators to enroll new individuals by capturing their demographic and biometric information, such as name, date of birth, address, and fingerprints, etc.</p>
            <p className={css.description}>To identify already enrolled individuals, IDMS interacts with CABIS (Thales Automatic Biometric Identifying System), that uses biometric data, such as fingerprints or facial recognition, to match the enrolled individuals with the information stored in database.</p>
            <p className={css.description}>IDMS can be used in various industries, such as government agencies, healthcare, financial services, and many others...</p>

            <h5 className={css.textSectionInfo}>Keywords:</h5>
            <div className={css.keywords} style={{marginTop: 10}}>
                <Chip label="Angular" color="primary" variant="outlined" size='small'/>
                <Chip label="Spring Boot" color="primary" variant="outlined" size='small'/>
                <Chip label="Micro-services" color="primary" variant="outlined" size='small'/>
                <Chip label="Java 11" color="primary" variant="outlined" size='small'/>
                <Chip label="RabbitMQ" color="primary" variant="outlined" size='small'/>
                <Chip label="Liquibase" color="primary" variant="outlined" size='small'/>
                <Chip label="Flowable" color="primary" variant="outlined" size='small'/>
                <Chip label="JasperReports" color="primary" variant="outlined" size='small'/>
                <Chip label="Oracle Database" color="primary" variant="outlined" size='small'/>
                <Chip label="Jenkins" color="primary" variant="outlined" size='small'/>
                <Chip label="Sonarqube" color="primary" variant="outlined" size='small'/>
                <Chip label="Fortify" color="primary" variant="outlined" size='small'/>
                <Chip label="NexusIQ" color="primary" variant="outlined" size='small'/>
                <Chip label="Mercurial" color="primary" variant="outlined" size='small'/>
                <Chip label="Jira/Confluence" color="primary" variant="outlined" size='small'/>
            </div>
        </div>
    </div>
);

export default Thales;
